<div class="page-container">    
    <div>
        <div *ngIf="userData" class="category-title">Current user name: {{userData.name}}</div>
        <div *ngIf="userData" class="category-title">Current user email: {{userData.email}}</div>
        <div *ngIf="userData" class="category-title">Current user phone: {{userData.phone}}</div>
        <div *ngIf="userData" class="category-title">Current user role: {{userData.role}}</div>
        <div *ngIf="userData" class="category-title">Current user notifications enabled: {{userData.notificationsEnabled}}</div>
        <!-- <div *ngIf="userData && userData.notificationsEnabled">
            <div *ngIf="userData.notificationsPlatforms.email" class="category-title">Current user notifications by email: {{userData.notificationsPlatforms.email}}</div>
            <div *ngIf="userData.notificationsPlatforms.sms" class="category-title">Current user notifications by SMS: {{userData.notificationsPlatforms.sms}}</div>
            <div *ngIf="userData.notificationsPlatforms.push" class="category-title">Current user notifications by push: {{userData.notificationsPlatforms.push}}</div>
        </div> -->
        
    </div>
    
</div>

